// This is a custom filter UI for selecting values where values come from a static (fixed) list that is set upfront

import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useAsyncDebounce } from "react-table";

function CreateStaticSelectColumnFilter(values: Array<any>) {
  let StaticSelectColumnFilter = function StaticSelectColumnFilter({
    column: { filterValue, setFilter },
  }: {
    column: any;
  }) {
    const [value, setValue] = useState(filterValue);
    const onChange = useAsyncDebounce((value) => {
      setFilter(value || undefined);
    }, 300);

    // Render a multi-select box
    return (
      <Form.Select
        className="mt-2"
        value={filterValue}
        onChange={(e: any) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
      >
        <option value="">All</option>
        {values.map((option: any, i: any) => (
          <option key={i} value={option}>
            {option}
          </option>
        ))}
      </Form.Select>
    );
  };

  return StaticSelectColumnFilter;
}

export { CreateStaticSelectColumnFilter };
